import {useEffect, useState} from 'react';
import {Label} from '@trussworks/react-uswds';
import {Value, isValidPhoneNumber} from 'react-phone-number-input';
import Input from 'react-phone-number-input/input';
import metadata_client_account from '../../../lib/metadata-client-account.json';
import {SetValidationMessages} from '../../../types/form-types';
import {addOrRemoveValidationMessage} from '../../../lib/utils';

export interface FormPhoneInputProps {
  phone: string;
  handleChange: (value?: Value) => void;
  setValidationMessages: SetValidationMessages;
  is_required?: boolean;
  is_disabled?: boolean;
}

export default function FormPhoneInput({
  phone,
  handleChange,
  setValidationMessages,
  is_required,
  is_disabled,
}: FormPhoneInputProps) {
  const [isValid, setIsValid] = useState(true);

  useEffect(() => {
    const is_number_valid = phone ? isValidPhoneNumber(phone) : !is_required;
    addOrRemoveValidationMessage({
      is_condition_met: !is_number_valid,
      err_message: metadata_client_account.phone.validation_message,
      setValidationMessages,
    });

    setIsValid(is_number_valid);
  }, [is_required, phone, setValidationMessages]);

  return (
    <>
      <Label htmlFor="phone" className="maxw-none">
        <span className="text-primary text-semibold">{metadata_client_account.phone.title}</span>
      </Label>
      <Input
        className={`usa-input ${isValid ? '' : 'usa-input--error'}`}
        id="phone"
        name="phone"
        type="tel"
        defaultCountry="US"
        value={phone}
        onChange={handleChange}
        disabled={is_disabled}
      />
    </>
  );
}
